import React from 'react';
import './Safety.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';

const Safety = () => {
    return (
        <section className='safty-section pt-100 section-bg section-common pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <SectionTitle 
                    subTitle="Safety"
                    title="We put the safety first"
                    description="At our practice, your health and safety are our highest priorities. We follow strict infection control protocols and adhere to the latest clinical safety standards to ensure a clean, sterile, and secure environment for every patient. From the moment you walk in, you can trust that you're in safe, experienced hands."
                />

                <div className="safety-video ratio ratio-16x9">
                    <iframe
                        src="https://www.youtube.com/embed/4l9jGjp60t8"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{width: '100%', height: '100%'}}
                    />
                </div>
            </div>
        </section>
    );
};

export default Safety;